/**
 * The opening count on the opening-correction sheet: the figure counted when the shift opened, as recorded, and,
 * when a correction (or the previous close's corrected count) changes it, what it now reads (ADR-027). "As
 * recorded" is never the corrected figure.
 */
export function openingCountText(
  recordedMinor: number | null,
  effectiveMinor: number,
  money: (minor: number) => string,
): string {
  const recorded = recordedMinor ?? effectiveMinor;
  const corrected =
    effectiveMinor !== recorded ? ` · reads ${money(effectiveMinor)} as corrected` : '';
  return `Opening count as recorded: ${money(recorded)}${corrected}.`;
}
